/** Open onboarding dock (Mise en route) from empty states, help links, or tour finish. */
export type GuideOpenRequest = {
  packId?: string;
  /** Re-fetch readiness before open (e.g. after Terminer). */
  refresh?: boolean;
};

type Listener = (req: GuideOpenRequest) => void;

const listeners = new Set<Listener>();

export function subscribeOpenGuide(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function openGuideOverlay(req: GuideOpenRequest = {}): void {
  for (const fn of listeners) fn(req);
}
